import { OrderDetailsComponent } from "./order-details.component";
import { connect } from 'react-redux'
import { Orders } from "@components/orders";
import { UserTasks } from '@components/user-tasks';
import { DocsTemplates } from "@components/modules/docs-templates";
import withStyles from '@material-ui/core/styles/withStyles';
import combineStyles from "~/utils/styles";
import modal from '@style/modal'
import styles from '@components/orders/modals/new-order/styles';

const mapStateToProps = (state, props) => ({
    context: state.context || {},
});

const actions = {
    getOrderDetails: Orders.actions.getOrderDetails,
    getAllClientOrders: Orders.actions.getAllClientOrders,
    updateOrderDetails: Orders.actions.updateOrderDetails,
    getOrderTasksList: UserTasks.actions.getOrderTasksList,
    updateOrderComment: Orders.actions.updateOrderComment,
    attachOrderFile: Orders.actions.attachOrderFile,
    sendOrderAction: Orders.actions.sendOrderAction,
    getCallUrl: Orders.actions.getCallUrl,
    getOrderBankTransactions: Orders.actions.getOrderBankTransactions,
    getOrderCost: Orders.actions.getOrderCost,
    createOrderCost: Orders.actions.createOrderCost,
    getOrderShortlink: Orders.actions.getOrderShortlink,
    deleteOrderDocument: DocsTemplates.actions.deleteOrderDocument,
    updateOrderStatus: Orders.actions.updateOrderStatus,
};

export const OrderDetailsContainer = connect(mapStateToProps, actions)((withStyles(combineStyles(modal, styles))(OrderDetailsComponent)));
